import { AfterViewChecked, Directive, ElementRef, Inject, Renderer2 } from '@angular/core';
import {AppConfig} from '../models/config/app-config';
import {PresentationMode} from '../common/enums';
import {APP_CONFIG} from '../app.config';

@Directive({
  selector: '[appReadonlyBehaviour]'
})
export class ReadonlyBehaviourDirective implements AfterViewChecked {

  constructor (private _elRef: ElementRef,
               private _renderer: Renderer2,
               @Inject(APP_CONFIG) private appConfig: AppConfig) {
  }

  ngAfterViewChecked() {
    if (this.appConfig.presentationMode === PresentationMode.AP2 ) {
      const elements = this._elRef.nativeElement.querySelectorAll('input, select');
      elements.forEach(element => {
        if (element) {
          this._renderer.setAttribute(element, 'disabled', 'disabled');
        }
      });
    }
  }
}
